import { oz } from '@weft/utils';

export const ShareInvoicesRequestSchema = oz.array(
  oz.object({
    emailOverride: oz.string().email().optional(),
    invoiceId: oz.string(),
  }).openapi('shareInvoicesRequest'),
);

export type ShareInvoicesRequest = oz.infer<typeof ShareInvoicesRequestSchema>;